import { COLUMN_DATA_TYPE } from '../../../../../shared/constants/list-view/cell-type.constant';

export const COLLEGE_PATH_LIST_COLUMNS = [
  {
    human: 'College list',
    key: 'collegeName',
    cellType: COLUMN_DATA_TYPE.SECTION_HEADER,
    cellConfig: {},
    dataType: null,
    orderBy: null,
  },
  {
    human: 'Status',
    key: 'status',
    cellType: COLUMN_DATA_TYPE.GENERIC,
    cellConfig: { type: 'pathStatus' },
    dataType: null,
    orderBy: null,
  },
  {
    human: 'Due by',
    key: 'dueBy',
    cellType: COLUMN_DATA_TYPE.GENERIC,
    cellConfig: {},
    dataType: null,
    orderBy: null,
  },
];
